import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { toHTML } from 'ngx-editor';
import { Subject } from 'rxjs';
import { CfFtDialogService } from './add-own-template-dialog.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { RichTextDocumentComponent } from '../richTextDocument/rich-text-document/rich-text-document.component';
import { CommonModule } from '@angular/common';
import { snackbarService } from '@one/web-components';

@Component({
  selector: 'dl-add-own-template-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule, RichTextDocumentComponent, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-own-template-dialog.component.html',
  styleUrl: './add-own-template-dialog.component.scss'
})
export class AddOwnTemplateDialogComponent {
  public templateColumn: any;
  public templateData: any;
  public newMessageTemplate: Subject<any> = new Subject<any>();
  public isNewFromTemplate = true;
  public isSaveBtnDisabled: boolean = true;
  public selectedRow = [];
  public textDoc = '';
  public msgTemplateSubjectFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public notificationData: any;
  public templateSubject: string = '';
  public templateBody: string = '';
  public allTemplates: any;
  public messageType: string = '';
  visible: boolean;
  @Input() data: any;
  @Input() messageDta: any;
  @Output() closeDialog = new EventEmitter<void>();
  public inputData = {}
  public inputData2 = {}
  templateId: any;
  @Output() templateUpdated = new EventEmitter<any>();

  public constructor(private _QnSbnDataService: QnSbnDataServiceService, private qnsbnservice: QnSbnService, private changeDetectorRef: ChangeDetectorRef) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      const input = changes['data'].currentValue;
  
      this.templateColumn = input.columnData;
      this.allTemplates = input.allTemplates;
      this.messageType = input.messageType;
      this.templateData = input.tableData;
  
      if (this.templateData?.templateId ||this.templateData) {
        const subject = this.templateData.templateDetails?.templateSubject || this.templateData.templateSubject || this.templateData?.reminderMessage || '';
        const body = this.templateData.templateDetails?.templateBody || this.templateData.templateBody || this.templateData?.reminderSubject || '';
  
        this.templateSubject = subject;
        this.templateBody = body;
  
        this.msgTemplateSubjectFormControl.patchValue(this.templateSubject);
        this.textDoc = this.templateBody;
      } else {
        this.templateSubject = '';
        this.templateBody = '';
        this.msgTemplateSubjectFormControl.reset();
        this.textDoc = '';
      }
    }
  }
  
  ngOnInit(): void {
    this.msgTemplateSubjectFormControl.valueChanges.subscribe(() => {
      this.getSaveButtonStatus();
    });
  
    this._QnSbnDataService.mappingData$.subscribe(observer => {
      this.notificationData = observer['localNotificationId'];
    });
  }
  public updateMsgTemplate(): void {
    if (this.templateSubject === this.msgTemplateSubjectFormControl.value && this.templateBody === this.textDoc) {
      this.snackBarMessage('positive', 'Template does not have any changes to update');
      this.isSaveBtnDisabled = true;
      return;
    }

    const templateExist = this.allTemplates?.some(template =>
      template.templateDetails?.templateBody === this.textDoc &&
      template.templateDetails?.templateSubject === this.msgTemplateSubjectFormControl.value);

    if (templateExist) {
      this.snackBarMessage('positive','Template already exist with same data. Please verify the template.');

      return;
    }

    let newTemplateData = {};
    let responseMessage = '';
    if (this.templateData?.templateId) {
      newTemplateData = {
        "templateId": this.templateData?.templateId,
        "templateSubject": this.msgTemplateSubjectFormControl.value,
        "templateBody": this.textDoc,
        "notificationType": this.notificationData?.Type,
        "messageType": this.messageType,
        "templateLanguage": this.notificationData?.LocalNotificationLanguage
      };
      responseMessage = "Template updated successfully.";
    } else {
      newTemplateData = {
        "templateSubject": this.msgTemplateSubjectFormControl.value,
        "templateBody": this.textDoc,
        "notificationType": this.notificationData?.Type,
        "messageType": this.messageType,
        "templateLanguage": this.notificationData?.LocalNotificationLanguage
      };
      if (this.messageType === 'Email') {
        responseMessage = "Message template successfully Added.";
      }
      else if (this.messageType === 'Reminder') {
        responseMessage = "Reminder template successfully Added.";
      }
      else {
        responseMessage = "Template successfully Added.";
      }
    }

    this.qnsbnservice.createUpdateMessageTemplate(newTemplateData).subscribe({
      next: (responseData: any) => {
        if (responseData && responseData.templateId) {  
          const finalTemplate = { ...responseData, rowIndex: this.data?.rowIndex };
          this.qnsbnservice.setTemplate(finalTemplate);
        }
        this.snackBarMessage('positive', responseMessage);
        this.templateUpdated.emit({
          updatedData: {
            templateSubject: this.msgTemplateSubjectFormControl.value,
            templateBody: this.textDoc,
            rowIndex: this.data?.rowIndex
          }
        });
        
        
        if (responseData?.messageType === 'Email') {
          this.qnsbnservice.getMessageTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe({
            next: (resData: any) => {
              if (resData.errorMessage) {
                this.snackBarMessage('alarm',resData.errorMessage.errorMessage)
              } else {
                const finalTemplate = { data: resData.MessageTemplates, rowIndex: this.data?.rowIndex };
                this.qnsbnservice.setTemplate(finalTemplate);
              }
            },
            error: (error: HttpErrorResponse) => {
              this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
            }
          });
        }

        if (this.messageType === 'Reminder') {
          this.qnsbnservice.getReminderTemplate(this.notificationData?.Type, this.notificationData?.LocalNotificationLanguage).subscribe({
            next: (resData: any) => {
              if (resData.errorMessage) {
                this.snackBarMessage('alarm', resData.errorMessage.errorMessage);
  
              } else {
                const finalTemplate = {  data: resData.MessageTemplates, rowIndex: this.data?.rowIndex };
                this.qnsbnservice.setTemplate(finalTemplate);
               
              }
            },
            error: (error: HttpErrorResponse) => {
              this.qnsbnservice.httpErrorHandler(error, 'Could not fetch Reminder templates.');
            }
          });
        }
        this.closeDialog.emit();
      },
      error: (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not save Template.');
      }
    });
    this.changeDetectorRef.detectChanges();
  }
  

  public onKeyupSubjectName(evt) {
    evt.preventDefault();
  }

  public onBlurSubjectName(evt: any) {
    const value = this.msgTemplateSubjectFormControl.value;
    if (typeof value === 'string') {
      this.msgTemplateSubjectFormControl.setValue(value.trim());
    }
  }
  
  public getSelectedRowInTemplate(rows: any): void {
    this.selectedRow = rows.messageSelected;
    const isSelected = this.selectedRow.length > 0;
  }

  public setRTETextadd(evt): void {
    this.textDoc = toHTML(evt);
    this.getSaveButtonStatus();
  }

  public getSaveButtonStatus(): void {
    if (this.msgTemplateSubjectFormControl.status === 'VALID' && this.textDoc && this.textDoc !== '<p></p>') {
      this.isSaveBtnDisabled = false;
    } else {
      this.isSaveBtnDisabled = true;
    }
  }

  snackBarMessage(status:any,message:string){
    snackbarService.show({
      message: message, 
      snackbarProps: {
        status: status,
        direction: 'horizontal',
        showClose: true,
        elevated: false,
        duration: 5000,
        verticalPlacement: 'top',
        horizontalPlacement: 'right',
      }
    });
  }

  
}